import { render, staticRenderFns } from "./IrOrderReturn.vue?vue&type=template&id=d31d6dea&"
import script from "./IrOrderReturn.vue?vue&type=script&lang=js&"
export * from "./IrOrderReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports